import EDC from '@/components/games/shared/globals';

/**
 *
 */
EDC.Games.NameSelect.NewNameButton = function (scene) {
  this.scene = scene;
  this.container = null;
  this.bg = null;
  this.buttonImg = null;
  this.textNormal = null;
  this.textOver = null;
  this.clickCallback = null;
  this.wandBackground1 = null;
  this.wandBackground2 = null;
  this.wandForeground = null;
  this.wand = null;
  this.wandRays = null;
  this.isBusy = false;
  this.cursorManager = scene.cursorManager;

  return this;
};
/**
 *
 */
EDC.Games.NameSelect.NewNameButton.prototype.create = function (clickCallback) {
  this.clickCallback = clickCallback;
  this.container = this.scene.add.container(0, 0);
  this.bg = this.scene.add.sprite(0, 0, 'name-selection-new-name-bg');
  this.wand = this.scene.add.sprite(120, -20, 'name-selection-wand');
  this.buttonImg = this.scene.add.sprite(0, 125, 'name-selection-new-name-button');
  this.textNormal = this.scene.add.sprite(0, 125, 'name-selection-new-name-normal');
  this.textNormal.setScale(1.3);
  this.textOver = this.scene.add.sprite(0, 125, 'name-selection-new-name-over');
  this.textOver.setScale(1.3);
  this.wandBackground1 = this.scene.add.sprite(230, -100, 'name-selection-wand-bg-1');
  this.wandBackground2 = this.scene.add.sprite(230, -100, 'name-selection-wand-bg-2');
  this.wandForeground = this.scene.add.sprite(230, -100, 'name-selection-wand-fg-1');
  this.wandBackground1.setAlpha(0);
  this.wandBackground2.setAlpha(0);
  this.wandForeground.setAlpha(0);

  this.container.add([this.wandBackground1, this.wandBackground2, this.bg,
    this.wand, this.buttonImg, this.wandForeground, this.textNormal, this.textOver]);

  this.textOver.setAlpha(0);

  this.buttonImg.setInteractive();
  this.buttonImg.on('pointerover', this.onOver, this);
  this.buttonImg.on('pointerout', this.onOut, this);
  this.buttonImg.on('pointerup', this.onUp, this);

  this.cursorManager.setDefaultDraggableEvents(this.buttonImg);

  this.scene.events.on(this.scene.gameConfig.signals.S_WAND_RAYS_DONE, this.raysDone, this);
  return this;
};
/**
 *
 */
EDC.Games.NameSelect.NewNameButton.prototype.raysDone = function () {
  this.scene.tweens.add({
    targets: [this.wandBackground1, this.wandBackground2],
    alpha: 0,
    duration: 200,
    ease: 'Linear',
    onComplete: () => {
      this.isBusy = false;
    },
  });
  if (this.clickCallback) {
    this.clickCallback();
  }
};
/**
 *
 */
EDC.Games.NameSelect.NewNameButton.prototype.onUp = function () {
  if (this.isBusy) return;
  this.isBusy = true;
  this.scene.tweens.add({
    targets: this.wandBackground1,
    alpha: 1,
    duration: 100,
    ease: 'Linear',
  });
  this.scene.tweens.add({
    targets: this.wandBackground2,
    alpha: 1,
    duration: 200,
    ease: 'Linear',
    onComplete: () => {
      this.scene.tweens.add({
        targets: this.wandForeground,
        alpha: 1,
        duration: 140,
        ease: 'Linear',
        yoyo: true,
        onComplete: () => {
          this.scene.rays.animate();
        },
      });
    },
  });
};
/**
 *
 */
EDC.Games.NameSelect.NewNameButton.prototype.onOver = function () {
  this.scene.tweens.add({
    targets: this.textOver,
    alpha: 1,
    duration: 100,
    ease: 'Linear',
  });
};
/**
 *
 */
EDC.Games.NameSelect.NewNameButton.prototype.onOut = function () {
  this.scene.tweens.add({
    targets: this.textOver,
    alpha: 0,
    duration: 100,
    ease: 'Linear',
  });
};
/**
 *
 */
EDC.Games.NameSelect.NewNameButton.prototype.setScale = function (scale) {
  this.container.setScale(scale);
};
/**
 *
 */
EDC.Games.NameSelect.NewNameButton.prototype.setPosition = function (x, y) {
  this.container.setPosition(x, y);
};

export default EDC.Games.NameSelect.NewNameButton;
